module.exports = __webpack_public_path__ + "static/media/fileSizeExceeded.9b054e4a.png";